import { ref } from "vue";

type LogLevel = "DEBUG" | "INFO" | "WARN" | "ERROR"

export const logLevel = ref<LogLevel>(loadLogLevel())

function loadLogLevel(): LogLevel {
  const saved = localStorage.getItem("logLevel")
  if(saved) {
    if(["DEBUG", "INFO", "WARN", "ERROR"].includes(saved)) {
      return saved as LogLevel
    } else {
      localStorage.setItem("logLevel", "ERROR")
      return "ERROR"
    }
  } else {
    localStorage.setItem("logLevel", "ERROR")
    return "ERROR"
  }
}

export function setLogLevel(level: LogLevel) {
  logLevel.value = level
  localStorage.setItem("logLevel", level)
}

export const log = {
  debug: (...args: unknown[]) => {
    if(logLevel.value === "DEBUG") {
      const time = new Date().toISOString()
      console.log(time, "[DEBUG]", ...args)
    }
  },
  info: (...args: unknown[]) => {
    if(["DEBUG", "INFO"].includes(logLevel.value)) {
      const time = new Date().toISOString()
      console.log(time, "[INFO]", ...args)
    }
  },
  warn: (...args: unknown[]) => {
    if(["DEBUG", "INFO", "WARN"].includes(logLevel.value)) {
      const time = new Date().toISOString()
      console.log(time, "[WARN]", ...args)
    }
  },
  error: (...args: unknown[]) => {
    if(["DEBUG", "INFO", "WARN", "ERROR"].includes(logLevel.value)) {
      const time = new Date().toISOString()
      console.log(time, "[ERROR]", ...args)
    }
  },
}
